// extracted by mini-css-extract-plugin
export default {"addSongSheetBox":"BWkGTIXDAVf8EJG140rH"};